import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Home from './pages/Home';
import BusinessHub from './pages/BusinessHub';
import ModuleGateway from './pages/ModuleGateway';
import TopicView from './pages/TopicView';
import Settings from './pages/Settings';
import EditTopic from './pages/EditTopic';
import PragyaAI from './components/PragyaAI';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <AppProvider>
      <div className="App devanagari-ui">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<BusinessHub />} />
            <Route path="/login" element={<ModuleGateway />} />
            <Route path="/register" element={<ModuleGateway />} />
            <Route path="/car-service" element={<ModuleGateway />} />
            <Route path="/karmkand" element={<Home />} />
            <Route path="/topic/:topicId" element={<TopicView />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/topic/:topicId" element={<EditTopic />} />
            <Route path="*" element={<BusinessHub />} />
          </Routes>
        </BrowserRouter>
        <PragyaAI />
        <Toaster position="top-center" richColors />
      </div>
    </AppProvider>
  );
}

export default App;
